{
  "version": 1,
  "asset_id": "07b5fa87-dd96-4de7-bf12-90e71e2d8f1b",
  "project_id": "ba939065-ecb3-4567-a218-3200eee84f15",
  "url": "/__l5e/assets-v1/07b5fa87-dd96-4de7-bf12-90e71e2d8f1b/form-433b.jpg",
  "r2_key": "a/v1/ba939065-ecb3-4567-a218-3200eee84f15/07b5fa87-dd96-4de7-bf12-90e71e2d8f1b/form-433b.jpg",
  "original_filename": "form-433b.jpg",
  "size": 139115,
  "content_type": "image/jpeg",
  "created_at": "2026-06-15T15:38:59Z"
}
